// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ChartPieSliceBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M11.727 14.58a1.5 1.5 0 0 0 .773-1.311V5.092a1.5 1.5 0 0 0-2.125-1.363 13.533 13.533 0 0 0-7.816 13.534 1.5 1.5 0 0 0 2.22 1.172l6.948-3.855ZM9.5 7.758v4.625l-3.899 2.162A10.549 10.549 0 0 1 9.5 7.758Zm18.235 1.574c-.014-.03-.03-.058-.046-.087a.96.96 0 0 0-.05-.079A13.507 13.507 0 0 0 16 2.5 1.5 1.5 0 0 0 14.5 4v11.191l-9.602 5.593a1.499 1.499 0 0 0-.538 2.057A13.5 13.5 0 0 0 29.5 16a13.403 13.403 0 0 0-1.765-6.668ZM17.5 5.606a10.51 10.51 0 0 1 6.75 3.905l-6.75 3.933V5.606ZM16 26.5a10.558 10.558 0 0 1-8.196-3.938l8.927-5.2.045-.024 8.974-5.23A10.499 10.499 0 0 1 16 26.5Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
